$('.event-item__content button[data-url]').on('click', function() {
  var { url, target } = $(this).data();
  if (target) {
    window.open(url, target);
  } else {
    window.location.href = url;
  }
  return false;
});
